export const tooltipKeys = {
  'executive-insights': [
    'executive-preamble',
    'executive-apps-received',
    'executive-pass-thru',
    'executive-hires',
    'executive-tth-bench',
    'executive-offer-bench',
    'executive-dropoff-bench',
    'executive-gender-slope',
    'executive-source-slope',
  ],
  'overall-report': [
    'overall-preamble',
    'source-categories-for-apps',
    'source-categories-for-hires',
    'data-table-general',
  ],
  'inbound-report': [
    'inbound-preamble',
    'source-categories-for-apps',
    'source-categories-for-hires',
    'inbound-apps-from-free-sources',
    'inbound-hires-from-free-sources',
    'inbound-apps-from-paid-sources',
    'inbound-hires-from-paid-sources',
    'inbound-apps-from-general-sources',
    'inbound-hires-from-general-sources',
    'inbound-apps-from-niche-sources',
    'inbound-hires-from-niche-sources',
    'data-table-general',
  ],
  'outbound-report': [
    'outbound-preamble',
    'source-categories-for-apps',
    'source-categories-for-hires',
    'outbound-apps-from-prospecting-sources',
    'outbound-hires-from-prospecting-sources',
    'outbound-apps-from-agency-sources',
    'outbound-hires-from-agency-sources',
    'data-table-general',
  ],
  'gender-report': [
    'gender-warning',
    'gender-preamble',
    'gender-by-stage',
    'gender-male-vs-female',
    'gender-female-apps',
    'gender-female-hires',
    'gender-male-apps',
    'gender-male-hires',
    'data-table-general',
  ],
  'drop-off': [
    'dropoff-warning',
    'dropoff-preamble',
    'dropoff-highest-proportion-by-stage',
    'dropoff-by-stage',
    'dropoff-overall-net-dropoff-rate',
    'dropoff-overall-net-drop-off-rate-benchmark',
    'dropoff-table',
  ],
  'pass-through': [
    'passthrough-warning',
    'passthrough-preamble',
    'passthrough-by-stage',
    'passthrough-number-of-candidates',
    'passthrough-overall',
    'passthrough-apps-for-one-hire',
    'passthrough-table',
  ],
  'compliance-report': [
    'compliance-preamble',
    'compliance-salary-disclosure',
    'compliance-diversity-accommodation',
    'compliance-regulatory',
    'compliance-missing-perks-benefits',
    'compliance-exclusionary-language',
  ],
  'employer-brand-report': [
    'easy-wins-preamble',
    'easy-wins-incomplete-jobs',
    'employer-brand-job-board',
    'easy-wins-long-jobs',
    'employer-brand-evp',
    'employer-brand-location',
  ],
  'job-performance-report': [
    'confidence-gap-preamble',
    'confidence-gap-reporting-structure',
    'job-performance-title-optimization',
    'confidence-gap-years-of-experience',
    'job-perf-pref-requirements',
  ],
  'hiring-report': [
    'hiring-preamble',
    'hiring-number-of-hires',
    'hiring-offer-acceptance-rate',
    'hiring-time-to-hire',
    'hiring-current-number-of-open-offers',
    'benchmark-range',
    'benchmark-range',
    'hiring-gender-distribution',
    'hiring-source-categories',
    'hiring-table',
  ],
  'recruiting-performance': [
    'recruiting-perf-preamble',
  ],
  'language-snapshot': [
    'language-snapshot-preamble',
  ],
  'content-snapshot': [
    'content-snapshot-preamble',
  ],
  usage: [
    'usage-report-preamble',
  ],
  'weekly-snapshot': [
    'weekly-snapshot-preamble',
  ],
  'demographic-survey-report': [
    'demo-survey-preamble',
    'demo-survey-submission',
    'demo-survey-insights-line',
    'demo-survey-insights-bar',
    'demo-survey-data-table',
    'demo-survey-req-table',
    'demo-survey-source-table',
  ],
  'job-architecture': [
    'architecture-alerts',
  ],
  'employee-acknowledgements': [
    'acknowledgement-email-failed-alert',
    'acknowledgement-alert-no-ack',
    'acknowledgement-alert-incomplete',
    'acknowledgement-alert-profile-changed',
    'acknowledgement-alert-out-of-date',
    'acknowledgement-header-dept',
    'acknowledgement-header-profile',
    'acknowledgement-header-current-ack',
    'acknowledgement-header-last-signed',
    'acknowledgement-slider-header-profile',
    'acknowledgement-slider-header-created_date',
    'acknowledgement-slider-header-status',
  ],
  'federal-flsa-dashboard': [
    'flsa-report-profile',
    'flsa-report-job-level',
    'flsa-report-form-submitted-by',
    'flsa-report-flsa-status',
    'flsa-report-exemption-basis',
    'flsa-report-alerts',
    'flsa-report-alert-no-survey',
    'flsa-report-alert-out-of-date',
    'flsa-report-alert-mismatched',
    'flsa-report-alert-out-of-sla',
  ],
  'approvals-library': [
    'approvals-dashboard-days',
  ],
};

export const preambleKeys = {
  // Operational
  'weekly-snapshot': 'weekly-snapshot-preamble',
  'recruiting-performance': 'recruiting-perf-preamble',
  'language-snapshot': 'language-snapshot-preamble',
  'content-snapshot': 'content-snapshot-preamble',
  usage: 'usage-report-preamble',
  // Actionable
  'compliance-report': 'compliance-preamble',
  'employer-brand-report': 'easy-wins-preamble',
  'job-performance-report': 'confidence-gap-preamble',
  // Process
  'executive-insights': 'executive-preamble',
  'gender-report': 'gender-preamble',
  'drop-off': 'dropoff-preamble',
  'pass-through': 'passthrough-preamble',
  'hiring-report': 'hiring-preamble',
  // Source
  'overall-report': 'overall-preamble',
  'inbound-report': 'inbound-preamble',
  'outbound-report': 'outbound-preamble',

  'demographic-survey-report': 'demo-survey-preamble',
};
